import ActivityName from "./ActivityName";
export default ActivityName;
